import React, { Component } from "react";
import {Helmet} from 'react-helmet'

class PageHelmet extends Component{
    render(){
        return(
            <React.Fragment>
                <Helmet>
                    <title>Battle of the Idols </title>
                    <meta name="description" content="Battle of the Idols" />
                </Helmet>
            </React.Fragment>
        )
    }
}


export default PageHelmet;
